import React, {useRef, useState} from "react";
import TourCardIndividual from "../TourCard/TourCardIndividual";
import s from "./TourHorizontalScroller.module.scss";
import useScrollerDots from "../../hooks/useScrollerDots";

const TourHorizontalScroller = ({
                                    tours=[],
                                    loadMore,
                                    hasMore,
                                    loading
                                })=>{
    const scrollerRef = useRef(null);
    const {
        dots,
        activeDot,
        handleScroll
    } = useScrollerDots(
        scrollerRef,
        [tours]
    );
    const [isDown, setIsDown] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const onMouseDown = (e) => {
        const slider = scrollerRef.current;
        setIsDown(true);
        setStartX(
            e.pageX - slider.offsetLeft
        );
        setScrollLeft(
            slider.scrollLeft
        );
    };
    const onMouseLeave = () => {
        setIsDown(false);
    };
    const onMouseUp = () => {
        setIsDown(false);
    };
    const onMouseMove = (e) => {
        if (!isDown) return;
        e.preventDefault();
        const slider = scrollerRef.current;
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 1.5;
        slider.scrollLeft =
            scrollLeft - walk;
    };
    const handleScrollLoad = ()=>{

        const el =
            scrollerRef.current;

        if(!el) return;
        handleScroll();
        const nearEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 300;
        if(nearEnd && hasMore && !loading){
            loadMore();
        }
    };
    if (!tours.length) {
        return (
            <div className={s.empty}>
                この場所のツアーはありません。
            </div>
        );
    }
    const dotCount =
        scrollerRef.current
            ? Math.ceil(
                scrollerRef.current.scrollWidth /
                scrollerRef.current.clientWidth
            )
            : 1;
    return (
        <div className={s.wrapper}>
            <div
                ref={scrollerRef}
                className={s.scroller}
                onScroll={handleScrollLoad}
                onMouseDown={onMouseDown}
                onMouseMove={onMouseMove}
                onMouseUp={onMouseUp}
                onMouseLeave={onMouseLeave}
            >
                {
                    tours.map(tour => (
                        <div
                            key={tour.id}
                            className={s.card}
                        >
                            <TourCardIndividual
                                item={tour}
                            />
                        </div>
                    ))
                }
            </div>
            <div className={s.dotContainer}>
                {Array.from({
                    length: dots
                }).map((_, index) => (
                    <span
                        key={index}
                        className={`
                                                        ${s.dot}
                                                                                        ${
                            activeDot === index
                                ? s.activeDot
                                : ""
                        }
                                                    `}
                    />
                ))
                }
            </div>
        </div>
    );
};
export default TourHorizontalScroller;